import { Injectable, signal, WritableSignal } from '@angular/core';
import { LANDING_FILTERS_INITIAL, LIMIT } from '../landing-page.filters';
import { SearchFilter } from '../../../_shared/components/search-filters/search-filters.component';

@Injectable()
export class LandingPageStateService {
  constructor() {}

  limit = signal(LIMIT);
  selectedFilter: WritableSignal<SearchFilter | null> = signal(LANDING_FILTERS_INITIAL[0]);
  currentSlug = signal<string | null>(null);

  setLimit(value: number) {
    this.limit.set(value);
  }

  increaseLimit(step: number) {
    this.limit.update(v => v + step);
  }

  setSelectedFilter(filter: SearchFilter) {
    this.selectedFilter.set(filter);
  }

  initForSlug(slug: string) {
    if (this.currentSlug() !== slug) {
      this.reset();
      this.currentSlug.set(slug);
    }
  }

  reset() {
    this.limit.set(LIMIT);
    this.selectedFilter.set(LANDING_FILTERS_INITIAL[0]);
  }
}
